import toast from '../../helpers/toast';
import {
  FETCH_CONFIG_REQUEST,
  FETCH_CONFIG_SUCCESS,
  FETCH_CONFIG_FAILURE,
  GENERAL_REQUEST,
  GENERAL_FAILURE,
  CONFIG_UPDATE_REFERRAL_TYPE_FIELD,
} from '../../constants/ActionTypes';
import configApi from '../../api/config';
import { isConfigFetching, getReferralTypes } from '../getters/config';
import { timeoutPromise } from '../../utils';

export const fetchConfig = () => (dispatch, getState) => {
  if (isConfigFetching(getState())) {
    return Promise.resolve();
  }

  dispatch({
    type: FETCH_CONFIG_REQUEST,
  });

  return configApi
    .getConfig()
    .then((data) => {
      return dispatch({
        type: FETCH_CONFIG_SUCCESS,
        data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: FETCH_CONFIG_FAILURE,
        data: error,
      });
    });
};

export const setConfigLiveFeedPool =
  (poolsConfigYaml = '') =>
  async (dispatch) => {
    try {
      dispatch({
        type: GENERAL_REQUEST,
      });

      await configApi.setConfigLiveFeedPool(poolsConfigYaml);

      await timeoutPromise(100);

      dispatch({
        type: FETCH_CONFIG_REQUEST,
      });

      const fetchConfig = await configApi.getConfig();

      dispatch({
        type: FETCH_CONFIG_SUCCESS,
        data: fetchConfig,
      });

      toast.success('LiveFeedPool Saved');
      return Promise.resolve('');
    } catch (error) {
      toast.error('Failed to save LiveFeedPool');
      return Promise.reject(error);
    }
  };

export const setActiveFeed =
  ({ poolName, participant }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GENERAL_REQUEST,
      });

      const setActiveFeed = await configApi.setActiveFeed({
        poolName,
        participant,
      });

      await timeoutPromise(100);

      dispatch({
        type: FETCH_CONFIG_REQUEST,
      });

      const fetchConfig = await configApi.getConfig();

      dispatch({
        type: FETCH_CONFIG_SUCCESS,
        data: fetchConfig,
      });

      if (setActiveFeed && setActiveFeed.data && setActiveFeed.data.message) {
        toast.success(setActiveFeed.data.message);
      }

      return setActiveFeed;
    } catch (error) {
      dispatch({
        type: GENERAL_FAILURE,
        data: error,
      });

      return Promise.reject();
    }
  };

export const saveReferralTypes = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GENERAL_REQUEST,
    });

    const referralTypes = getReferralTypes(getState());
    const setActiveFeed = await configApi.saveReferralTypes(referralTypes);

    await timeoutPromise(100);

    dispatch({
      type: FETCH_CONFIG_REQUEST,
    });

    const fetchConfig = await configApi.getConfig();

    dispatch({
      type: FETCH_CONFIG_SUCCESS,
      data: fetchConfig,
    });

    if (setActiveFeed && setActiveFeed.data && setActiveFeed.data.message) {
      toast.success(setActiveFeed.data.message);
    }

    return setActiveFeed;
  } catch (error) {
    dispatch({
      type: GENERAL_FAILURE,
      data: error,
    });

    return Promise.reject(error);
  }
};

export const updateReferralTypeField =
  ({ id, fieldName, value }) =>
  (dispatch) => {
    dispatch({
      type: CONFIG_UPDATE_REFERRAL_TYPE_FIELD,
      data: {
        id,
        fieldName,
        value,
      },
    });
  };
